export function hasUnicodeStyling(str: string) {
  return /[\u0080-\uFFFF]/.test(str);
}
